module.exports = __webpack_public_path__ + "static/media/header-nx-logo-route-finder.35ea2dee.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header-nx-logo-route-finder.svg
// module id = 155
// module chunks = 0